var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"cookie_bar"},[(_vm.type !== undefined && _vm.type === 'modal')?_c('cookie-modal',{on:{"confirm":_vm.confirm}}):_vm._e(),_vm._v(" "),(_vm.type !== undefined && _vm.type === 'banner')?_c('cookie-banner',{on:{"confirm":_vm.confirm}}):_vm._e()],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38d8a4cb","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/cookies/CookieNotification.vue
// module id = 688
// module chunks = 5